// extracted by mini-css-extract-plugin
export var border = "_bf-b";
export var circle = "_bf-3";
export var circleInner = "_bf-5";
export var disabled = "_bf-1";
export var focused = "_bf-a";
export var md = "_bf-8";
export var radioButton = "_bf-0";
export var radioInput = "_bf-2";
export var selected = "_bf-9";
export var sm = "_bf-7";
export var text = "_bf-4";
export var xs = "_bf-6";